//// App Settings

import { APIFetchStudio, RequestHeaders } from "@certa/network";
import { slugify } from "@certa/studio/src/utils/general";
import type { HashMap } from "@certa/types";
import {
  appSettingsModelCreator,
  appSettingsPayloadCreator,
  appSettingsPermissionListModelCreator,
  appSettingsSchemaModelCreator
} from "../models/appSettings.model";
import type {
  AppSettingPermissionList,
  AppSettings,
  AppSettingsRaw,
  AppSettingsJSONSchemaRaw
} from "../types/appSettings.types";
import { splitFileNameAndExtension } from "../utils/files.utils";

export function getAppSettingsDB() {
  const requestOptions: RequestInit = {
    method: "GET",
    headers: RequestHeaders.GET,
    credentials: "include"
  };
  return APIFetchStudio<AppSettingsRaw>(
    `platform-settings/`,
    requestOptions
  ).then(appSettingsModelCreator);
}

// export function getAppSettingsSchema() {
//   const requestOptions: RequestInit = {
//     method: "GET",
//     headers: RequestHeaders.GET,
//     credentials: "include"
//   };
//   return APIFetchStudio<AppSettingsDBResponse>(
//     `platform-settings/schema-for-validation/`,
//     requestOptions
//   ).then(appSettingsFromDBModelCreator);
// }

export function getAppSettings(savepointId: number): Promise<AppSettings> {
  const requestOptions: RequestInit = {
    method: "GET",
    headers: RequestHeaders.GET,
    credentials: "include"
  };
  return APIFetchStudio<AppSettingsRaw>(
    `platform-settings/${savepointId}/`,
    requestOptions
  ).then(appSettingsModelCreator);
}

export function setAppSettings(params: {
  savepointId: number;
  appSettings: AppSettings;
}) {
  const appSettingsRaw = appSettingsPayloadCreator(params.appSettings);

  const requestOptions: RequestInit = {
    method: "POST",
    headers: RequestHeaders.POST,
    credentials: "include",
    body: JSON.stringify(appSettingsRaw)
  };
  return APIFetchStudio(
    `platform-settings/${params.savepointId}/`,
    requestOptions
  );
}

export function getPermissionsList() {
  const requestOptions: RequestInit = {
    method: "GET",
    headers: RequestHeaders.GET,
    credentials: "include"
  };
  return APIFetchStudio<AppSettingPermissionList>(
    `config-permissions-list/`,
    requestOptions
  ).then(appSettingsPermissionListModelCreator);
}

export function uploadPlatformSettingsFiles(payload: {
  branchSavepoint: string;
  model: string;
  file: Blob;
}) {
  const formData = new FormData();

  formData.append("model", payload.model);
  formData.append("branch_savepoint", payload.branchSavepoint);

  // Slugify the file name
  const [fileName, extension] = splitFileNameAndExtension(
    (payload.file as File).name
  );
  formData.append("file", payload.file, `${slugify(fileName)}.${extension}`);

  const requestOptions: RequestInit = {
    method: "POST",
    headers: RequestHeaders.POST,
    credentials: "include",
    body: formData
  };

  delete (requestOptions.headers as HashMap)["Content-Type"];

  return APIFetchStudio<{ path: string }>(
    `platform-settings/upload-file/`,
    requestOptions
  );
}

export function getAppSettingsSchema() {
  const requestOptions: RequestInit = {
    method: "GET",
    headers: RequestHeaders.GET,
    credentials: "include"
  };
  return APIFetchStudio<AppSettingsJSONSchemaRaw>(
    `platform-settings/schema-for-validation/`,
    requestOptions
  ).then(appSettingsSchemaModelCreator);
}
